import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  TextField,
} from "@mui/material";
import { Form, useLoaderData, useNavigate } from "react-router-dom";
import { Result } from "../../types/Result";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { User } from "./type";

export default function UserForm() {
  const data = useLoaderData() as Result<User>;
  const navigate = useNavigate();
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Form method="post">
        <TextField
          placeholder="Id"
          type="text"
          name="id"
          value={data.data?.id}
          fullWidth
          margin="dense"
          label="Id"
          disabled
        />
        <TextField
          placeholder="Kullanıcı Adı"
          type="text"
          name="userName"
          defaultValue={data.data?.userName}
          fullWidth
          margin="dense"
          label="Kullanıcı Adı"
          required
          disabled
        />
        <TextField
          placeholder="Email"
          type="text"
          name="email"
          defaultValue={data.data?.email}
          fullWidth
          margin="dense"
          label="Email"
          required
          disabled
        />
        <TextField
          placeholder="Telefon"
          type="text"
          name="phoneNumber"
          defaultValue={data.data?.phoneNumber}
          fullWidth
          margin="dense"
          label="Telefon"
          required
          disabled
        />
        <TextField
          placeholder="Kilit Bitiş Tarihi"
          type="string"
          name="lockoutEnd"
          defaultValue={data.data?.lockoutEnd ?? ""}
          fullWidth
          margin="dense"
          label="Kilit Bitiş Tarihi"
          required
          disabled
        />
        <FormControlLabel
          name="phoneNumberConfirmed"
          control={
            <Checkbox defaultChecked={data.data?.phoneNumberConfirmed} />
          }
          label="Telefon Onaylandı"
        />
        <TextField
          placeholder="Başarısız Giriş Sayısı"
          type="number"
          name="accessFailedCount"
          defaultValue={data.data?.accessFailedCount}
          fullWidth
          margin="dense"
          label="Başarısız Giriş Sayısı"
          required
          disabled
        />
        <Button fullWidth type="submit" variant="contained">
          Kaydet
        </Button>
      </Form>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "absolute", bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<ChecklistIcon />}
          tooltipTitle={"Jeton"}
          onClick={() => navigate("jeton")}
        />
      </SpeedDial>
    </Box>
  );
}
